<template>
  <div />
</template>

<script>
export default {
  emits: ['ready'],
  async mounted () {
    const { status, payload } = await this.$get('v1/system/loadSystemSettings')
    if (status === 'success') {
      this.$store.commit('setSystemSettings', payload)
      this.$emit('ready')
    }
  }
}
</script>
